import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=741bb0ca&scoped=true&"
var script = {}
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=741bb0ca&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741bb0ca",
  null
  
)

export default component.exports